import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';

export interface ScrollFlagState {
    scrollModalFlag: boolean;
    btnFocus:boolean;
}

@Injectable({
    providedIn: 'root',
})
export class ModalScroll {

    private scrollFlag = new BehaviorSubject<ScrollFlagState>({scrollModalFlag:false,btnFocus:false});
    scrollFlagState = this.scrollFlag.asObservable();

    constructor() { }

    handleModalScrollFlag(scrollFlagState: ScrollFlagState) {
        this.scrollFlag.next(scrollFlagState);
    }
    
}
